import { NodeWrapper } from "./NodeWrapper";
import { AddOutlined as Add, ContentCopyOutlined as ContentCopy, DeleteOutlined as Delete, LinkOutlined as Link, PhoneInTalkOutlined as PhoneInTalk, TouchAppOutlined as TouchApp } from '@mui/icons-material';
import React, { memo, useState } from "react";
import { Handle } from "react-flow-renderer";

import { Tooltip as CoreTooltip, IconButton as CoreIconButton } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { HelpOutline as HelpOutlineIcon } from '@mui/icons-material';


import { useNodeStorage } from "../../../stores/useNodeStorage";
import { mkHeaderStyle, HEADER_ICON_STYLE, HEADER_TEXT_STYLE, mkInputHandleStyle, mkOutputHandleStyle } from "./nodeStyles";
import { i18n } from "../../../translate/i18n";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#1e293b',
    color: '#f8fafc',
    maxWidth: 380,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #334155',
    padding: '12px 14px',
    borderRadius: '8px',
    fontFamily: "'Inter', 'Roboto', sans-serif",
    lineHeight: 1.5,
  },
  arrow: { color: '#1e293b' },
}))(CoreTooltip);

const useStyles = makeStyles((theme) => ({
  pulseIcon: {
    color: '#ffffff',
    borderRadius: '50%',
    animation: '$glowPulse 1.5s infinite',
  },
  '@keyframes glowPulse': {
    '0%': { boxShadow: '0 0 0 0 rgba(255, 255, 255, 0.9)' },
    '70%': { boxShadow: '0 0 0 8px rgba(255, 255, 255, 0)' },
    '100%': { boxShadow: '0 0 0 0 rgba(255, 255, 255, 0)' },
  },
}));

// ─────────────────────────────────────────────────────────────────────────────
// Nodo: Botones Interactivos — EXCLUSIVO META API OFICIAL
// Plan 904 — 15-05-2026
// Tipos:
//   • Botones de Respuesta Rápida (hasta 3) → generan cables de salida
//   • Botón CTA URL → abre navegador, NO continúa el flujo
//   • Botón CTA Llamada → marca teléfono, NO continúa el flujo
// ─────────────────────────────────────────────────────────────────────────────

const META_GREEN = "#1a6b3c";
const META_LIGHT = "#e8f5ee";
const CABLE_COLOR = "#1a6b3c";
const CTA_WARNING_COLOR = "#b45309";
const CTA_WARNING_BG = "#fffbeb";
const CTA_WARNING_BORDER = "#fcd34d";
export default memo(({
  data,
  isConnectable,
  id,
  selected
}) => {
  const classes = useStyles();
  const storageItems = useNodeStorage();
  const buttons = data.buttons || [{
    id: "btn_1",
    text: ""
  }];
  const ctaUrl = data.ctaUrl || {
    label: "",
    url: ""
  };
  const ctaPhone = data.ctaPhone || {
    label: "",
    phone: ""
  };
  const hasCta = ctaUrl.label || ctaUrl.url || ctaPhone.label || ctaPhone.phone;
  return <NodeWrapper id={id} selected={selected} color="#3F51B5">
      {/* ── Floating Toolbar ─────────────────────────────────────────────── */}
      

      {/* ── Handle de entrada (izquierda) ────────────────────────────────── */}
      <Handle type="target" position="left" style={mkInputHandleStyle("#3F51B5")} isConnectable={isConnectable} />

      {/* ── Encabezado ───────────────────────────────────────────────────── */}
      <div style={{ ...mkHeaderStyle("#3F51B5"), justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <TouchApp style={HEADER_ICON_STYLE} />
        <div style={HEADER_TEXT_STYLE}>
          {data.name || i18n.t("flowBuilder.interactiveButtons.name")}
        </div>
        </div>
        <HtmlTooltip
          arrow
          title={
            <React.Fragment>
              <div style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '8px', color: '#818cf8' }}>
                💡 {i18n.t("flowBuilder.tooltips.button.title")}
              </div>
              <div style={{ marginBottom: '0' }}>
                <div dangerouslySetInnerHTML={{ __html: i18n.t("flowBuilder.tooltips.button.body") }} />
              </div>
            </React.Fragment>
          }
          placement="right"
        >
          <CoreIconButton size="small" style={{ padding: '4px', marginLeft: '2px' }} className={classes.pulseIcon}>
            <HelpOutlineIcon style={{ fontSize: '15px' }} />
          </CoreIconButton>
        </HtmlTooltip>
      </div>

      {/* ── Cuerpo del mensaje ───────────────────────────────────────────── */}
      <div style={{
      padding: "10px 12px 6px 12px"
    }}>
        <div style={{
        color: "#475569",
        fontSize: "12px",
        lineHeight: "1.5",
        maxHeight: "60px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitLineClamp: "3",
        WebkitBoxOrient: "vertical",
        backgroundColor: "#f8fafc",
        padding: "7px 9px",
        borderRadius: "6px",
        border: "1px solid #f1f5f9"
      }}>
          {data.body || <span style={{
          color: "#94a3b8",
          fontStyle: "italic"
        }}>{i18n.t("flowBuilder.interactiveButtons.messageBody")}...</span>}
        </div>
      </div>

      {/* ── Botones de Respuesta Rápida ──────────────────────────────────── */}
      <div style={{
      padding: "4px 12px 6px 12px"
    }}>
        <div style={{
        fontSize: "10px",
        fontWeight: "600",
        color: "#64748b",
        marginBottom: "4px",
        textTransform: "uppercase",
        letterSpacing: "0.5px"
      }}>
          {i18n.t("flowBuilder.interactiveButtons.quickReplyButtons")}
        </div>
        {buttons.map((btn, idx) => <div key={btn.id || idx} style={{
        position: "relative",
        marginBottom: "4px"
      }}>
            <div style={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "#f8fafc",
          border: `1px solid ${META_GREEN}40`,
          borderRadius: "6px",
          padding: "5px 8px",
          fontSize: "12px",
          color: META_GREEN,
          fontWeight: "500",
          minHeight: "28px"
        }}>
              <TouchApp sx={{
            width: "12px",
            height: "12px",
            marginRight: "5px",
            flexShrink: 0
          }} />
              <span style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}>
                {btn.text || <span style={{
              color: "#94a3b8",
              fontStyle: "italic"
            }}>{i18n.t("flowBuilder.interactiveButtons.addOption")} {idx + 1}...</span>}
              </span>
            </div>
            {/* Cable de salida por cada botón de respuesta */}
            <Handle type="source" position="right" id={`btn-${btn.id || idx}`} style={{ ...mkOutputHandleStyle("#3F51B5"), right: "-24px" }} isConnectable={isConnectable} />
          </div>)}
      </div>

      {/* ── Botones CTA (URL y/o Llamada) ───────────────────────────────── */}
      {hasCta && <div style={{
      padding: "4px 12px 10px 12px"
    }}>
          <div style={{
        fontSize: "10px",
        fontWeight: "600",
        color: "#64748b",
        marginBottom: "4px",
        textTransform: "uppercase",
        letterSpacing: "0.5px"
      }}>
            {i18n.t("flowBuilder.interactiveButtons.ctaTitle")}
          </div>

          {/* CTA URL */}
          {(ctaUrl.label || ctaUrl.url) && <div style={{
        marginBottom: "4px"
      }}>
              <div style={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "#f8fafc",
          border: "1px solid #93c5fd",
          borderRadius: "6px",
          padding: "5px 8px",
          fontSize: "12px",
          color: "#1d4ed8",
          fontWeight: "500"
        }}>
                <Link sx={{
            width: "12px",
            height: "12px",
            marginRight: "5px",
            flexShrink: 0
          }} />
                <span style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}>
                  {ctaUrl.label || i18n.t("flowBuilder.interactiveButtons.urlLabel").replace(" (máx. 20)", "")}
                </span>
              </div>
              {/* Advertencia CTA */}
              <div style={{
          backgroundColor: "#f8fafc",
          border: "1px solid #e2e8f0",
          borderRadius: "4px",
          padding: "3px 6px",
          fontSize: "10px",
          color: CTA_WARNING_COLOR,
          marginTop: "2px"
        }}>
                {i18n.t("flowBuilder.interactiveButtons.ctaWarning")}
              </div>
            </div>}

          {/* CTA Llamada */}
          {(ctaPhone.label || ctaPhone.phone) && <div>
              <div style={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "#f8fafc",
          border: "1px solid #86efac",
          borderRadius: "6px",
          padding: "5px 8px",
          fontSize: "12px",
          color: "#15803d",
          fontWeight: "500"
        }}>
                <PhoneInTalk sx={{
            width: "12px",
            height: "12px",
            marginRight: "5px",
            flexShrink: 0
          }} />
                <span style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}>
                  {ctaPhone.label || i18n.t("flowBuilder.interactiveButtons.phoneLabel").replace(" (máx. 20)", "")}
                </span>
              </div>
              <div style={{
          backgroundColor: "#f8fafc",
          border: "1px solid #e2e8f0",
          borderRadius: "4px",
          padding: "3px 6px",
          fontSize: "10px",
          color: CTA_WARNING_COLOR,
          marginTop: "2px"
        }}>
                {i18n.t("flowBuilder.interactiveButtons.ctaWarning")}
              </div>
            </div>}
        </div>}
      
    
      <div style={{
          marginTop: "4px",
          borderTop: "1px dashed #e2e8f0",
          padding: "10px 12px 10px 12px"
      }}>
          <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
              <div style={{
                  fontSize: "11px",
                  color: "#64748b",
                  fontWeight: "600",
                  paddingLeft: "26px"
              }}>
                  {i18n.t("flowBuilder.interactiveButtons.fallback", { defaultValue: "Respuesta Libre / Fallback" })}
              </div>
              <Handle
                  type="source"
                  position="right"
                  id="fallback"
                  style={{ ...mkOutputHandleStyle("#ef4444"), right: "-24px" }}
                  isConnectable={isConnectable}
              />
          </div>
      </div>
    </NodeWrapper>;
});
